import React from "react";
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  Img,
  ImgWrapper,
  InfoContainer,
  BackgroundImage,
} from "./styles";

import { Subtitle, Title } from "../styles";

import { dados } from "./dados";

function InfoSession() {
  const { headline, description, img, imgStart, start, alt } = dados;

  return (
    <BackgroundImage>
      <InfoSec>
        <InfoContainer>
          <InfoRow imgStart={imgStart}>
            <InfoColumn>
              <TextWrapper>
                <Title>{headline}</Title>
                <Subtitle>{description}</Subtitle>
              </TextWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={img} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
        </InfoContainer>
      </InfoSec>
    </BackgroundImage>
  );
}

export default InfoSession;
